(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fxl-blog-article"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeArticles = () => {
      document.querySelectorAll('[data-fxl-article]').forEach((articleRoot) => {
        const content = articleRoot.querySelector('.fxl-article__content');
        const toc = articleRoot.querySelector('[data-fxl-article-toc]');

        if (content && toc) {
          const list = toc.querySelector('ol');
          const headings = Array.from(content.querySelectorAll('h2'));
          list.replaceChildren();

          headings.forEach((heading, index) => {
            if (!heading.id) heading.id = `fxl-guide-section-${index + 1}`;
            const item = document.createElement('li');
            const link = document.createElement('a');
            link.href = `#${heading.id}`;
            link.textContent = heading.textContent.trim();
            item.appendChild(link);
            list.appendChild(item);
          });

          toc.hidden = headings.length === 0;
        }

        content?.querySelectorAll('table').forEach((table) => {
          const labels = Array.from(table.querySelectorAll('thead th')).map((heading) => heading.textContent.trim());
          table.querySelectorAll('tbody tr').forEach((row) => {
            Array.from(row.querySelectorAll('td')).forEach((cell, index) => {
              cell.dataset.label = labels[index] || `Column ${index + 1}`;
            });
          });
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeArticles, { once: true });
    } else {
      initializeArticles();
    }
    document.addEventListener('shopify:section:load', initializeArticles);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const compactThreshold = 24;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (document.documentElement.classList.contains('mry-mobile-nav-open')) return;
      // A locked overlay reports scrollTop 0 without actually returning to the page top.
      if (document.body.style.position === 'fixed') return;

      this.header.classList.toggle('is-compact', scrollTop > compactThreshold);
      this.header.classList.toggle('scrolled-past-header', scrollTop > compactThreshold);
      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
(() => {
  const hydrateSwatches = (root = document) => {
    if (window.MRYLensSwatch) window.MRYLensSwatch.hydrate(root);
  };

  if (window.MRYLensSwatch) hydrateSwatches();
  else document.addEventListener('mry:lens-swatches-ready', () => hydrateSwatches(), { once: true });

  const gridContainer = document.getElementById('ProductGridContainer');
  if (gridContainer && !gridContainer.dataset.mrySearchObserverReady) {
    gridContainer.dataset.mrySearchObserverReady = 'true';
    new MutationObserver(() => hydrateSwatches(gridContainer)).observe(gridContainer, { childList: true, subtree: true });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mry-collection-product-grid"] && !Shopify.designMode) return;
  try {
    
(() => {
  const hydrateLensSwatches = () => window.MRYLensSwatch.hydrate(document);
  if (window.MRYLensSwatch) hydrateLensSwatches();
  else document.addEventListener('mry:lens-swatches-ready', hydrateLensSwatches, { once: true });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mry-frame-help"] && !Shopify.designMode) return;
  try {
    
(() => {
  const maxBytes = 10 * 1024 * 1024;
  document.querySelectorAll('[data-frame-uploads]').forEach(group => {
    const error = group.querySelector('[data-upload-error]');
    const syncErrors = () => {
      if (!error) return;
      const invalid = [...group.querySelectorAll('[data-frame-photo]')].find(input => !input.validity.valid);
      error.hidden = !invalid;
      error.textContent = invalid ? invalid.validationMessage : '';
    };
    group.querySelectorAll('[data-frame-photo]').forEach(input => {
      input.addEventListener('change', () => {
        const file = input.files && input.files[0];
        const card = input.closest('.mry-frame-help__upload-card');
        const label = card && card.querySelector('[data-upload-file]');
        input.setCustomValidity('');
        card?.classList.remove('has-file');
        if (label) label.textContent = 'No photo selected';
        if (!file) {
          syncErrors();
          return;
        }
        const validType = ['image/jpeg', 'image/png', 'image/webp'].includes(file.type)
          || (!file.type && /\.(jpe?g|png|webp)$/i.test(file.name));
        if (!validType) {
          input.setCustomValidity('Please choose a JPG, PNG or WEBP image.');
          syncErrors();
          input.reportValidity();
          return;
        }
        if (file.size > maxBytes) {
          input.setCustomValidity('Please choose an image of 10 MB or smaller.');
          syncErrors();
          input.reportValidity();
          return;
        }
        card?.classList.add('has-file');
        if (label) label.textContent = file.name;
        syncErrors();
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mry-homepage-v2-pro"] && !Shopify.designMode) return;
  try {
    
(() => {
  const hydrateLensSwatches = () => window.MRYLensSwatch.hydrate(document);
  if (window.MRYLensSwatch) hydrateLensSwatches();
  else document.addEventListener('mry:lens-swatches-ready', hydrateLensSwatches, { once: true });

  if (window.__mryColorPreviewReady) return;
  window.__mryColorPreviewReady = true;

  const controlSelector = '[data-mry-color-preview]';
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const previewColor = (control) => {
    const card = control.closest('[data-mry-color-card]');
    if (!card || control.disabled || card.closest('[data-fxl-catalog-results]')) return;

    const image = card.querySelector('[data-mry-color-image]');
    const labels = card.querySelectorAll('.mryp-catalog__color-label');

    card.querySelectorAll(controlSelector).forEach((button) => {
      button.setAttribute('aria-pressed', button === control ? 'true' : 'false');
    });

    if (control.dataset.colorName) {
      labels.forEach((label) => {
        label.textContent = control.dataset.colorName;
      });
    }

    if (control.dataset.variantUrl) {
      card.querySelectorAll('[data-mry-product-destination]').forEach((destination) => {
        destination.href = control.dataset.variantUrl;
      });
    }

    if (!image || !control.dataset.previewSrc || image.dataset.previewSrc === control.dataset.previewSrc) {
      return;
    }

    if (window.FXLMotion) {
      image.dataset.previewSrc = control.dataset.previewSrc;
      window.FXLMotion.imageView(image, {
        image: control.dataset.previewSrc,
        srcset: control.dataset.previewSrcset || '',
        alt: control.dataset.previewAlt || image.alt,
      });
      return;
    }
    if (!reduceMotion.matches) image.classList.add('is-changing');
    image.dataset.previewSrc = control.dataset.previewSrc;
    image.src = control.dataset.previewSrc;
    if (control.dataset.previewSrcset) image.srcset = control.dataset.previewSrcset;
    if (control.dataset.previewAlt) image.alt = control.dataset.previewAlt;

    const reveal = () => image.classList.remove('is-changing');
    if (image.complete) {
      requestAnimationFrame(reveal);
    } else {
      image.addEventListener('load', reveal, { once: true });
      image.addEventListener('error', reveal, { once: true });
    }
  };

  document.addEventListener('pointerenter', (event) => {
    const control = event.target.closest?.(controlSelector);
    if (control && event.pointerType !== 'touch') previewColor(control);
  }, true);

  document.addEventListener('focusin', (event) => {
    const control = event.target.closest?.(controlSelector);
    if (control) previewColor(control);
  });

  document.addEventListener('click', (event) => {
    const control = event.target.closest?.(controlSelector);
    if (control) previewColor(control);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mry-oakley-model-directory"] && !Shopify.designMode) return;
  try {
    
(() => {
  const roots = document.querySelectorAll('[data-model-directory]:not([data-directory-ready])');
  roots.forEach((root) => {
    root.dataset.directoryReady = 'true';
    const search = root.querySelector('[data-model-search]');
    const clear = root.querySelector('[data-clear-filters]');
    const resultCount = root.querySelector('[data-result-count]');
    const emptyState = root.querySelector('[data-empty-state]');
    const entries = [...root.querySelectorAll('[data-model-entry]')];
    const sections = [...root.querySelectorAll('[data-directory-letter]')];
    const letterButtons = [...root.querySelectorAll('[data-letter-filter]')];
    let activeLetter = 'all';

    const initialQuery = new URL(window.location.href).searchParams.get('model');
    if (initialQuery) search.value = initialQuery;

    const normalize = (value) => value.toLowerCase().replace(/[^a-z0-9]/g, '');
    const matchesBase = (entry, query) => query.every((term) => entry.dataset.modelName.includes(term) || entry.dataset.modelCode.includes(term));

    const applyFilters = () => {
      const query = search.value.split(/\s+/).map(normalize).filter(Boolean);
      // A letter with no matches must not trap a new search.
      if (activeLetter !== 'all' && !entries.some((entry) => matchesBase(entry, query) && entry.dataset.modelLetter === activeLetter)) {
        activeLetter = 'all';
      }
      let visibleCount = 0;
      entries.forEach((entry) => {
        const visible = matchesBase(entry, query) && (activeLetter === 'all' || entry.dataset.modelLetter === activeLetter);
        entry.hidden = !visible;
        if (visible) visibleCount += 1;
      });
      sections.forEach((section) => {
        section.hidden = !section.querySelector('[data-model-entry]:not([hidden])');
      });
      letterButtons.forEach((button) => {
        const letter = button.dataset.letterFilter;
        const available = letter === 'all' || entries.some((entry) => matchesBase(entry, query) && entry.dataset.modelLetter === letter);
        button.disabled = !available;
        button.setAttribute('aria-pressed', String(letter === activeLetter));
      });
      resultCount.textContent = `${visibleCount} ${visibleCount === 1 ? 'model' : 'models'} available`;
      emptyState.hidden = visibleCount !== 0;
    };

    search.addEventListener('input', applyFilters);
    letterButtons.forEach((button) => button.addEventListener('click', () => {
      if (button.disabled) return;
      activeLetter = button.dataset.letterFilter;
      applyFilters();
      const firstSection = sections.find((section) => !section.hidden);
      if (activeLetter !== 'all' && firstSection) {
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        firstSection.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
      }
    }));
    clear.addEventListener('click', () => {
      search.value = '';
      activeLetter = 'all';
      applyFilters();
      search.focus();
    });
    applyFilters();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
